const AUTH_CHANNEL_NAME = "bevan-auth";

export const publishAuthLogout = () => {
    if (typeof BroadcastChannel === "undefined") {
        return;
    }

    const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
    channel.postMessage({ type: "logout" });
    channel.close();
};

export const subscribeToAuthLogout = (onLogout) => {
    if (typeof BroadcastChannel === "undefined") {
        return () => {};
    }

    const channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
    const handleMessage = ({ data }) => {
        if (data?.type === "logout") {
            onLogout();
        }
    };

    channel.addEventListener("message", handleMessage);
    return () => {
        channel.removeEventListener("message", handleMessage);
        channel.close();
    };
};
